'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _components2 = require('components');

var _reduxFormSubmitActions = require('actions/reduxFormSubmitActions');

var _authTokenActions = require('actions/authTokenActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    LoginPage: {
        displayName: 'LoginPage'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/containers/LoginPage.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var LoginPage = _wrapComponent('LoginPage')(function (_Component) {
    (0, _inherits3.default)(LoginPage, _Component);

    function LoginPage() {
        (0, _classCallCheck3.default)(this, LoginPage);
        return (0, _possibleConstructorReturn3.default)(this, (LoginPage.__proto__ || (0, _getPrototypeOf2.default)(LoginPage)).apply(this, arguments));
    }

    (0, _createClass3.default)(LoginPage, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                isAuthenticated = _props.isAuthenticated,
                redirect = _props.redirect;


            if (isAuthenticated) redirect();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                redirect = _props2.redirect,
                props = (0, _objectWithoutProperties3.default)(_props2, ['redirect']);


            return _react3.default.createElement(_components2.Login, (0, _extends3.default)({
                onSubmit: (0, _reduxFormSubmitActions.onSubmitActions)(_authTokenActions.AUTH_TOKEN_REQUESTED, _authTokenActions.AUTH_TOKEN_RECEIVED, _authTokenActions.AUTH_TOKEN_REQUEST_FAILED),
                onSubmitSuccess: redirect
            }, props));
        }
    }]);
    return LoginPage;
}(_react2.Component));

LoginPage.propTypes = {
    bookingId: _propTypes2.default.string.isRequired,
    customerId: _propTypes2.default.string,
    userName: _propTypes2.default.string,
    isAuthenticated: _propTypes2.default.bool.isRequired,
    redirect: _propTypes2.default.func.isRequired

    // TODO: mapStateToProps to pre-fill name, etc. from data
    //  retrieved from cache with hash, for login failure
};var mapStateToProps = function mapStateToProps(state) {
    return {
        bookingId: state.booking.id,
        customerId: state.user.customerId,
        userName: state.user.customerName,
        isAuthenticated: !!state.user.authorization || false
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    var redirectUrl = ownProps.location.query.redirect || '/';
    return {
        redirect: function redirect() {
            return dispatch((0, _reactRouterRedux.push)(redirectUrl));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginPage);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/containers/LoginPage.js
// module id = 1355
// module chunks = 0